import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Search = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Search' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M15,15 L22,22 L15,15 Z M9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 Z' />
  </StyledIcon>
);
